/**
 * F305(사장님 지시 2026-08-09): 화면의 날짜·시각은 **클라이언트(브라우저)
 * 로컬 시간**으로 보여 준다.
 *
 * 서버·DB 는 UTC 로 산다(운영 규약). 크레딧 내역이 UTC 그대로 화면에
 * 나가 "어느 나라 시간이냐"가 됐다 — 서버는 사용자의 시간대를 모른다.
 * 슬롯 설정 시간대(config.yaml timezone)로 바꾸는 안은 기각(사장님):
 * 해외 사용자에게는 그것도 남의 나라 시간이다. **브라우저가 안다.**
 *
 * 쓰는 법 — 템플릿이 UTC ISO 문자열을 표식에 싣는다:
 *     <span data-nx-utc="{{ row.created_at.isoformat() }}">UTC 폴백</span>
 * 부팅 때(그리고 팝업 조각이 들어올 때) 로컬 'YYYY-MM-DD HH:MM' 으로
 * 바꿔 넣는다. JS 가 없으면 UTC 폴백 글자가 그대로 남는다.
 */

function fmt(d: Date): string {
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} `
    + `${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function localizeUtc(root: ParentNode): void {
  root.querySelectorAll<HTMLElement>('[data-nx-utc]').forEach((el) => {
    const iso = el.getAttribute('data-nx-utc') || '';
    if (!iso) return;
    // 표식이 소박한 ISO(+00:00 없이)면 UTC 로 못 박는다 — 로컬로 오독 금지.
    const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + 'Z');
    if (Number.isNaN(+d)) return;               // 못 읽으면 폴백 글자 유지
    el.textContent = fmt(d);
    el.removeAttribute('data-nx-utc');           // 두 번 처리 방지
  });
}

export function initLocalTime(): void {
  localizeUtc(document);
  // 팝업 조각도 — modal.ts 가 조각을 그릴 때마다 알린다(nx:modal:load).
  document.addEventListener('nx:modal:load', (e: Event) => {
    const root = (e as CustomEvent).detail?.root as ParentNode | undefined;
    if (root) localizeUtc(root);
  });
}
